import { defineStore } from 'pinia'
import { preloadManager } from '@/front/services/PreloadManager.js'

export const AudioStore = defineStore('audio', {
  state: () => {
    return {
      player: null,
      currentTime: 0,
      playerState: {},
      src: null,
      clipId: null,
      requestedAt: null,
      startedAt: null,
    }
  },

  actions: {
    setPlayerState(state) {
      this.playerState = state
    },
    setSrc(src) {
      this.src = src
    },
    togglePlay() {
      this.playerState.playing ? this.player.pause() : this.player.play()
    },
    seekToPercentage(percentage) {
      log.info(2,"seekToPercentage", percentage)
      this.player.seek((percentage / 100) * this.playerState.duration)
    },
    async streamById(id) {
      log.info(2,"🌜 AudioStore streamById", id)
      this.requestedAt = Date.now()
      this.src = null
      this.clipId = id  // Store the clip ID

      // Check preload cache first
      const preloaded = preloadManager.getPreloadedClip(id)
      if (preloaded && preloaded.type === 'audio') {
        log.info(3,"🔊 AudioStore using preloaded audio", id)
        this.src = preloaded.url
        return Promise.resolve()
      }

      // Fallback to regular loading
      return this.Api.get(`/assets/stream/${id}`).then(response => {
        log.info(3,"🔊 AudioStore streamById", response.data)
        this.src = response.data.url
      })
    }
  },
  getters: {
    progress: (state) => Math.round((state.currentTime / state.playerState.duration) * 100),
  }
})